import { Stack } from '@mantine/core';
import { PatternSelect } from '../PatternSelect';
import { ManualBetAmountNumberInput } from './ManualBetAmountNumberInput';
import { ManualBetCashoutButton } from './ManualBetCashoutButton';
import { ManualBetMobileActions } from './ManualBetMobileActions';
import { ManualBetPickRandomBrickButton } from './ManualBetPickRandomBrickButton';
import { ManualBetPredefinedBets } from './ManualBetPredefinedBets';
import { ManualBetProfitCard } from './ManualBetProfitCard';
import { ManualBetStartButton } from './ManualBetStartButton';

export const ManualBetTab = () => {
  return (
    <Stack data-test-id="manual-bet-tab" gap={6}>
      <ManualBetAmountNumberInput />

      <ManualBetPredefinedBets />

      <PatternSelect />

      <ManualBetProfitCard />

      <ManualBetStartButton
        data-test-id="manual-bet-start-button"
        visibleFrom="lg"
      />

      <ManualBetMobileActions />

      <ManualBetCashoutButton
        data-test-id="manual-bet-cashout-button"
        visibleFrom="lg"
      />

      <ManualBetPickRandomBrickButton
        data-test-id="manual-bet-pick-random-brick-button"
        visibleFrom="lg"
      />
    </Stack>
  );
};
